import React, { useState } from "react";
import { Box, TextField, Chip, InputAdornment, IconButton } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

const TagManager = ({ tags, onChange, disabled }) => {
  const [tagInput, setTagInput] = useState("");

  const handleAddTag = () => {
    if (tagInput.trim() !== "") {
      onChange([...tags, tagInput.trim()]);
      setTagInput("");
    }
  };

  const handleDeleteTag = (tagToDelete) => {
    onChange(tags.filter((tag) => tag !== tagToDelete));
  };

  return (
    <Box>
      <TextField
        label="Add Tag"
        value={tagInput}
        onChange={(e) => setTagInput(e.target.value)}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            handleAddTag();
          }
        }}
        fullWidth
        disabled={disabled}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleAddTag} disabled={disabled}>
                <AddIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Box>
        {tags.map((tag, index) => (
          <Chip
            key={index}
            label={tag}
            onDelete={!disabled ? () => handleDeleteTag(tag) : undefined}
            style={{ margin: "4px", marginTop: "12px" }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default TagManager;